var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 20 40 28"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 28,
    x: 20,
    y: 20,
    fill: "#fff",
    rx: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ED0006",
    fillRule: "evenodd",
    d: "M40.285 40.016a7.62 7.62 0 0 1-5.058 1.924c-4.307 0-7.798-3.605-7.798-8.053s3.491-8.054 7.798-8.054c1.93 0 3.697.724 5.059 1.924a7.62 7.62 0 0 1 5.058-1.924c4.307 0 7.799 3.606 7.799 8.054s-3.492 8.053-7.799 8.053a7.62 7.62 0 0 1-5.059-1.924",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9A000",
    fillRule: "evenodd",
    d: "M40.286 40.016a8.15 8.15 0 0 0 2.74-6.13 8.15 8.15 0 0 0-2.74-6.129 7.62 7.62 0 0 1 5.058-1.924c4.307 0 7.799 3.606 7.799 8.054s-3.492 8.053-7.799 8.053a7.63 7.63 0 0 1-5.058-1.924",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    fillRule: "evenodd",
    d: "M40.285 40.017a8.15 8.15 0 0 0 2.74-6.13 8.15 8.15 0 0 0-2.74-6.13 8.15 8.15 0 0 0-2.74 6.13 8.15 8.15 0 0 0 2.74 6.13",
    clipRule: "evenodd"
  })));
};
export default SvgMastercard;